<!--数据分析主页-->
<template>
  <div class="welcome-container">
    <!--面包屑导航-->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>数据看板</el-breadcrumb-item>
    </el-breadcrumb>
    <!--订单统计信息-->

    <h3 class="orderMsg-title">订单统计信息</h3>
    <div class="orderMsg-container">
      <el-row :gutter="40">
        <el-col :span="4">
          <orderMsgCard class="no-deal-with-order orderMsgCard">
            <span slot="card-name" class="order-card-title">未处理订单</span>
            <span slot="card-count" class="order-card-count">{{ noDealWithOrder }}</span>
          </orderMsgCard>
        </el-col>
        <el-col :span="4">
          <orderMsgCard class="no-send orderMsgCard">
            <span slot="card-name" class="order-card-title">待发货订单</span>
            <span slot="card-count" class="order-card-count">{{ noSendCount }}</span>
          </orderMsgCard>
        </el-col>
        <el-col :span="4">
          <orderMsgCard class="wait-pay orderMsgCard">
            <span slot="card-name" class="order-card-title">待结算订单</span>
            <span slot="card-count" class="order-card-count">{{ waitPayCount }}</span>
          </orderMsgCard>
        </el-col>
        <el-col :span="4">
          <orderMsgCard class="checked-order orderMsgCard">
            <span slot="card-name" class="order-card-title">已成交订单</span>
            <span slot="card-count" class="order-card-count">{{ checkedOrderCount }}</span>
          </orderMsgCard>
        </el-col>
        <el-col :span="4">
          <orderMsgCard class="fail-order orderMsgCard">
            <span slot="card-name" class="order-card-title">失败订单</span>
            <span slot="card-count" class="order-card-count">{{ failOrder }}</span>
          </orderMsgCard>
        </el-col>
      </el-row>
    </div>
    <el-row :gutter="40">
        <el-col :span="8">
          <h3>商品排行榜</h3>
          <orderRankList></orderRankList>
        </el-col>
        <el-col :span="12">
          <h3>用户消费分析</h3>
          <userDataGraph></userDataGraph>
        </el-col>
      </el-row>
  </div>
</template>

<script>
import orderMsgCard from '../components/orderMsgCard'
import orderRankList from '../components/orderRankList'
import userDataGraph from '../components/userDataGraph'
export default {
  name: 'Welcome',
  data () {
    return {
      noDealWithOrder: 5, // 未处理订单数
      noSendCount: 19, // 待发货订单
      waitPayCount: 22, // 待结算订单
      checkedOrderCount: 10, // 已成交订单
      failOrder: 10// 失败订单
    }
  },
  components: {
    orderMsgCard,
    orderRankList,
    userDataGraph
  }
}
</script>

<style scoped>
  .orderMsgCard{
    text-align: center;
  }
  .orderMsgCard:hover{
    box-shadow: 0 5px 15px -5px rgba(0,0,0,.5);
  }
  .no-deal-with-order{
   background-color: #409EFF;
  }
 .orderMsg-container span{
   display: block;
   color: #fff;
 }
  .orderMsg-container span:nth-child(1){
    font-size: 17px;
    line-height: 53px;
  }
  .orderMsg-container span:nth-child(2){
    font-size: 28px;
  }
 .no-send{
   background-color: #d96363;
 }
 .wait-pay{
   background-color: #E6A23C;
 }
  .checked-order{
    background-color: #67C23A;
  }
  .fail-order{
    background-color: red;
  }
</style>
